import {PatchServiceOrderVariantPaymentTypeApiApiArg} from '@dms/api/workshop';

import {FormType} from '../types/ServiceOrderVariant';

type PaymentTypePatchBody = PatchServiceOrderVariantPaymentTypeApiApiArg['body'];

// Internal payment is always initiated automatically (the checkbox is read-only in the form).
const INTERNAL_AUTO_INITIATE_PAYMENT = true;

export function buildPaymentTypePatchBody(
  paymentType: FormType['paymentType']
): PaymentTypePatchBody {
  return {
    defaultPaymentType: paymentType.defaultPaymentType,
    cardPayment: paymentType.cardPayment?.isAllowed
      ? {
          ...paymentType.cardPayment,
          isAutoInitiatePayment: paymentType.cardPayment.isAutoInitiatePayment ?? false,
        }
      : {isAllowed: false, isAutoInitiatePayment: false},
    cashPayment: paymentType.cashPayment?.isAllowed
      ? {
          ...paymentType.cashPayment,
          isAutoInitiatePayment: paymentType.cashPayment.isAutoInitiatePayment ?? false,
          cashRegisterId: paymentType.cashPayment.isAutoInitiatePayment
            ? (paymentType.cashPayment.cashRegisterId ?? null)
            : null,
        }
      : {isAllowed: false, isAutoInitiatePayment: false, cashRegisterId: null},
    cashOnDeliveryPayment: paymentType.cashOnDeliveryPayment?.isAllowed
      ? paymentType.cashOnDeliveryPayment
      : {isAllowed: false},
    bankPayment: paymentType.bankPayment?.isAllowed ? paymentType.bankPayment : {isAllowed: false},
    internalPayment: paymentType.internalPayment?.isAllowed
      ? {
          ...paymentType.internalPayment,
          isAutoInitiatePayment: INTERNAL_AUTO_INITIATE_PAYMENT,
        }
      : {isAllowed: false, isAutoInitiatePayment: INTERNAL_AUTO_INITIATE_PAYMENT},
  };
}
